
import { createAsyncThunk } from "@reduxjs/toolkit";
import { toast } from "react-toastify"; // Import toast for displaying success or error messages
import { sendContactUsRequest } from "api/contactUsApi";


// Create AsyncThunk for sending a contact form request
export const contactUsCall = createAsyncThunk(
    "contactUsPage/contactUs", // Action type
    async ({ token, data }, { rejectWithValue, dispatch }) => {
        try {
            const response = await sendContactUsRequest(token, data); // Call the API function

            // If the request is successful, optionally show a success message
            toast.success("Successfully sent your request!");

            return response; // Return the response data
        } catch (error) {
            // Show an error toast message if the request fails
            toast.error("Failed to send your request, please try again later!");

            // Check for error response and reject with custom error message
            if (error.response && error.response.data) {
                return rejectWithValue(error.response.data);
            } else {
                return rejectWithValue(error);
            }
        }
    }
);